import DynamicIcon from "../ui/dynamic-icon";
import Button from "../ui/button";
import ButtonContent from "../ui/button-content";

/**
 * Full-screen fallback for when a required bootstrap request fails (e.g.
 * `BusinessProvider`'s developer-registration check) — same visual
 * language as `pages/404.js`'s `NotFoundTemplate`, but self-contained so
 * it can render in place of `children` from inside a context provider
 * rather than needing a page-level shell.
 */
const RequestFailed = ({ onRetry }) => {
    return (
        <div className="h-[100dvh] w-screen grid items-center justify-items-center content-center gap-[16px] text-center px-[20px]">
            <div className="h-[48px] w-[48px] rounded-full custom-bg-grey-50 border-[8px] custom-border-white-200 grid items-center justify-center">
                <DynamicIcon name="triangle-alert" size={20} color="custom-text-danger-500" />
            </div>
            <div className="grid gap-[4px] max-w-[320px]">
                <p className="poppins-medium text-[16px] leading-[24px] custom-text-grey-900">Request failed</p>
                <p className="text-[14px] leading-[21px] custom-text-grey-600">
                    Something went wrong loading your account. Please check your connection and try again.
                </p>
            </div>
            <Button handleClick={onRetry} additionalclasses="!w-fit !mt-0 !px-[24px]">
                <ButtonContent>Try again</ButtonContent>
            </Button>
        </div>
    );
};

export default RequestFailed;
